document.addEventListener('DOMContentLoaded', function() {
  const messageContainer = document.querySelector('.free-shipping-message');
  if (!messageContainer) return;

  function updateShippingMessage() {
    const cartSubtotal = parseInt(messageContainer.dataset.cartSubtotal);
    const customerCountry = messageContainer.dataset.customerCountry;
    const messageElement = messageContainer.querySelector('small');
    
    if (!messageElement) return;
    
    if (cartSubtotal < 5000 && customerCountry === 'DE') {
      messageElement.style.display = 'block';
    } else {
      messageElement.style.display = 'none';
    }
  }

  // Initial update
  updateShippingMessage();

  // Debug-Logging für Cart-Updates
  console.log('Shipping message handler initialized');

  // Event Listener für Warenkorb-Updates
  document.addEventListener('cart:updated', function(event) {
    console.log('Cart updated event fired:', event.detail); // Logging hinzugefügt
    if (messageContainer) {
      messageContainer.dataset.cartSubtotal = event.detail.cart.total_price;
      updateShippingMessage();
    }
  });
}); 